import { Link } from 'react-router-dom';
import { categories, platforms } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-200">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
                </div>
                <span className="text-lg font-bold text-foreground-50 font-heading whitespace-nowrap">
                  豆花视频
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-foreground-400">
                汇聚香蕉视频、红桃视频、蜜桃视频等优质平台，免费高清在线观看电视剧全集和最新电影，畅快追剧不缓冲。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-50 mb-4 font-heading">
                热门分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-50 mb-4 font-heading">
                合作平台
              </h4>
              <ul className="space-y-2.5">
                {platforms.map((p) => (
                  <li key={p.name}>
                    <span className="text-sm text-foreground-400">
                      {p.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-bold text-foreground-50 mb-4 font-heading">
                订阅更新
              </h4>
              <p className="text-sm text-foreground-400 mb-3 leading-relaxed">
                获取最新影视资讯和追剧提醒
              </p>
              <form
                className="flex flex-col sm:flex-row gap-2"
                data-readdy-form="newsletter"
                onSubmit={async (e) => {
                  e.preventDefault();
                  const form = e.currentTarget;
                  const formData = new FormData(form);
                  const honeypot = formData.get('phone_alt') as string;
                  if (honeypot && honeypot.trim() !== '') {
                    const msg = document.getElementById('footer-sub-msg');
                    if (msg) msg.textContent = '订阅成功！感谢您的关注。';
                    form.reset();
                    return;
                  }
                  try {
                    const url = 'https://form.readdy.ai/submit';
                    const res = await fetch(url, {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                      body: new URLSearchParams(
                        Array.from(formData.entries())
                          .filter(([k]) => k !== 'phone_alt')
                          .map(([k, v]) => [k, typeof v === 'string' ? v : ''])
                      ).toString(),
                    });
                    const msg = document.getElementById('footer-sub-msg');
                    if (res.ok) {
                      if (msg) msg.textContent = '订阅成功！感谢您的关注。';
                      form.reset();
                    } else {
                      const txt = await res.text();
                      if (msg) msg.textContent = txt.includes('spam') ? '提交失败，请稍后重试。' : '订阅失败，请稍后再试。';
                    }
                  } catch {
                    const msg = document.getElementById('footer-sub-msg');
                    if (msg) msg.textContent = '网络错误，请稍后再试。';
                  }
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入您的邮箱"
                  required
                  className="flex-1 px-3 py-2 text-sm rounded-lg border border-background-700 bg-background-800 text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                />
                <input
                  type="text"
                  name="phone_alt"
                  className="spam-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                </button>
              </form>
              <p id="footer-sub-msg" className="text-xs text-foreground-400 mt-2"></p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2025 豆花视频 douhuavideo.com 版权所有 | 本站所有内容均来自合作平台
              </p>
              <div className="flex items-center gap-4">
                <Link to="/about" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
                <span className="text-xs text-foreground-500">
                  联系邮箱: service@douhuavideo.com
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}